import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType, clearSignatureDifferenceType,
		setShowUpgradeCard } from '../../actions/localStates'
import { fromBytes } from '../../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux'
import i18next from 'i18next'
import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';

import QRPopup from './QRPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();

class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);
	}

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearSignatureDifferenceType()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	downloadSignedData() {
		// var name;
		// name = this.props.defaultState.fileWithDSName.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileWithDSName.substr(0, this.props.defaultState.fileWithDSName.lastIndexOf("."));
  //   	saveAs(this.props.defaultState.fileSignedData, name)
  		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$1');
        }

        var dataFileName = removeExtraExtensions(this.props.defaultState.fileWithDSName)
    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid;

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureType
					str += i18next.t("ds:signatureType") + signatureType + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureFormat
					str += i18next.t("ds:" + signatureFormat) + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());
	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), verticalOffset = 65;
		var img = 'data:image/png;base64,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'

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		doc.setFont('Roboto-Regular', 'normal');

		function footer(){ 
			doc.setFont("Roboto-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString()); //print number bottom right
		    doc.page += 1;
		};

		doc.page = 1;

		footer()
		
		doc.addImage(img, 'PNG', 10, 5, 60, 17)

		doc.setFontSize(8);
   		doc.text(i18next.t("instanceTitle"), 200, 9, {align:'right'});
   		doc.text(i18next.t("instanceAddress"), 200, 14, {align:'right'});
   		// doc.text("Тел.: +38 (044) 484-4612", 200, 20, {align:'right'});
   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
   		// doc.textWithLink("E-mail: info@cipher.com.ua", 200, 26, {align:'right'});
   		doc.textWithLink("Web: https://kredobank.com.ua", 200, 19, {url: 'https://kredobank.com.ua/', align:'right'});
   		doc.line(10, 24, 200, 24);

   		doc.setFont('Roboto-Regular', 'bold');
   		doc.setFontSize(18);
   		doc.text(i18next.t("clientForService"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolLabel"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Roboto-Regular', 'normal');
   		doc.text(i18next.t("protocolHeader"), 105, 53, {align:'center'});

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimeLabel"), 10, 58);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), 33, 58);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("verifyResultsLabel"), 10, 62);

   		doc.setFont('Roboto-Regular', 'normal');
   		doc.text(i18next.t("verifyResultsLabelFirstRow"), 62, 62);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 68);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(this.props.defaultState.fileWithDS.name, 55, 68);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 72);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, 56, 72);

   		// var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);doc.text(i18next.t("fileNameWithoutDS"), 10, 76);
   		doc.text(i18next.t("fileNameWithoutDS"), 10, 76);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);

   		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$1');
        }

        var dataFileName = removeExtraExtensions(this.props.defaultState.fileWithDS.name)
        doc.text(dataFileName, 56, 76);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 80);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, 58, 80);
   		// doc.text(i18next.t("verifyResultsLabelSecondRow": "verifyResultsLabelSecondRow"), 10, 69);

   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (verticalOffset + 70 > 290) {
				verticalOffset = 30;
				doc.addPage();
				footer()
				doc.setFont('Roboto-Regular', 'normal');

				// var str = this.generateTextResult();
				
				doc.addImage(img, 'PNG', 10, 5, 60, 17)

				doc.setFontSize(8);
		   		doc.text(i18next.t("instanceTitle"), 200, 9, {align:'right'});
		   		doc.text(i18next.t("instanceAddress"), 200, 14, {align:'right'});
		   		// doc.text("Тел.: +38 (044) 484-4612", 200, 20, {align:'right'});
		   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
		   		// doc.textWithLink("E-mail: info@cipher.com.ua", 200, 26, {align:'right'});
		   		doc.textWithLink("Web: https://kredobank.com.ua", 200, 19, {url: 'https://kredobank.com.ua/', align:'right'});
		   		doc.line(10, 24, 200, 24);

		   		// doc.setFont('Roboto-Regular', 'bold');
		   		// doc.setFontSize(18);
		   		// doc.text(i18next.t("clientForService"), 105, 40, {align:'center'});

		   		// doc.text(i18next.t("protocolLabel"), 105, 48, {align:'center'});

		   		// doc.setFontSize(10);
		   		// doc.setFont('Roboto-Regular', 'normal');
		   		// doc.text(i18next.t("protocolHeader"), 105, 53, {align:'center'});

		   		// doc.setFont("Roboto-Bold", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text(i18next.t("dateTimeLabel"), 10, 60);

		   		// doc.setFont("Roboto-Regular", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text(dateNow.toLocaleString(), 33, 60);

		   		// doc.setFont("Roboto-Bold", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text(i18next.t("verifyResultsLabel"), 10, 65);

		   		// doc.setFont('Roboto-Regular', 'normal');
		   		// doc.text(i18next.t("verifyResultsLabelFirstRow"), 62, 65);
		   		// doc.text(i18next.t("verifyResultsLabelSecondRow": "verifyResultsLabelSecondRow"), 10, 69);

		   		doc.setFontSize(10);
			}

			if (i === 0) {
				verticalOffset = verticalOffset + 24
			} else {
				verticalOffset = verticalOffset + 8
			}

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("red");
					doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
					doc.text(isValid, 28, verticalOffset);
				} else {
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("green");
					doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
					doc.text(isValid, 29, verticalOffset);
				}

				verticalOffset = verticalOffset + 5;
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("black");
				var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				doc.text(isQualified, 10, verticalOffset);

				if (this.props.defaultState.verifyResults[i].failureCause !== null && this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("red");
					doc.text(this.props.defaultState.verifyResults[i].failureCause, 10, verticalOffset);
				}


				verticalOffset = verticalOffset + 5;
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("black");
				doc.text(i18next.t("ds:signer"), 10, verticalOffset);
				doc.setFont("Roboto-Regular", 'normal');
				doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, 32, verticalOffset);

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, 27, verticalOffset);
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitle"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), 80, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, 35, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), 34, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Roboto-Regular", 'normal');
							doc.text(i18next.t("ds:tsIsMissing"), 72, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), 34, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), 80, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumberDS"), 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, 112, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), 83, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Roboto-Bold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDS"), 10, verticalOffset);
					            	doc.setFont("Roboto-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, 112, verticalOffset);
				            	}
				            }
				        }

					}
				}

				verticalOffset = verticalOffset + 5;
				doc.setTextColor("black");
        		doc.setFont("Roboto-Bold", 'normal');
            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
            	doc.setFont("Roboto-Regular", 'normal');
            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), 58, verticalOffset);

            	verticalOffset = verticalOffset + 5;
				doc.setTextColor("black");
        		doc.setFont("Roboto-Bold", 'normal');
            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
            	doc.setFont("Roboto-Regular", 'normal');
            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), 29, verticalOffset);

            	verticalOffset = verticalOffset + 5;
				doc.setTextColor("black");
        		doc.setFont("Roboto-Bold", 'normal');
            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
            	doc.setFont("Roboto-Regular", 'normal');
            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, 38, verticalOffset);

            	if (this.props.defaultState.verifyResults[i].signatureType) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), 39, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), 39, verticalOffset);
            	}

				if (this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("red");
				doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				doc.text(i18next.t("ds:notDefined"), 28, verticalOffset);

				var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
				doc.setFont("Roboto-Regular", 'normal');
				doc.setTextColor("black");

				verticalOffset = verticalOffset + 5;

				for (var c = 0; c < splitText.length; c += 1){
			        doc.text(10, verticalOffset, splitText[c]);
			        verticalOffset = verticalOffset + 5;
			    }
			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Roboto-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyServiceAddress"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("https://cryptocenter.kredobank.com.ua/", 10, verticalOffset + 5, {url: 'https://cryptocenter.cipher.kiev.ua/'});

   		// doc.output("dataurlnewwindow");
   		if (this.props.defaultState.fileInputName.length > 0) {
			doc.save(this.props.defaultState.fileInputName + ".pdf")
		} else {
			doc.save(this.props.defaultState.fileWithDSName + ".pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div><span className="font-weight-bold">{tsTypeString()}</span>{i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this;

		function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(_this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!_this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].signatureTimestamps).length === 0)) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
		    			</div>
		    				{
								verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{_this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					_this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			_this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{_this.props.defaultOptionState.generateQR ? <img src={_this.props.defaultState.verifyResultsForQR[i]} onClick={_this.handleShowQR.bind(_this, i)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" /> : null} </div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{_this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					_this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{i18next.t("ds:certEnded") + _this.formatDate(verifyResults[i].signerInfo.notAfter.value)}</b></p>
						            		}
						            		
						            		<p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{
							            verifyResults[i].isUntrustedValid
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }


        function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}

        if (!this.props.defaultOptionState.showUpgradeCard) {
        	generateVerifyResultsViewSimple(verifyResults)
        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}

        return divPtblg
    }

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;
		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
							: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileInputSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}

		                                  </div>
		                                  : <div>
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
		                                  		}
											</div>
		                                }
	                                </div>
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
	                                    {
											this.props.defaultState.fileWithDSSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultState.fileWithDSSelected
	                                    		? <div className="input-group mb-4">
													<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
												: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
	                                      </div>
	                                    
	                                }
                                </div>
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("verificationReportLabel")}</span>
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }
                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        {
		                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData")}</button>
		                        	</div>
		                        	: null
		                        }
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType, setShowUpgradeCard,
    	fromBytes
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);